<dtm-ui-select-field
    maxPanelHeight="320px"
    [isClearable]="false"
    [formControl]="countryFormControl"
    [placeholder]="'dtmUi.countrySelect.placeholder' | transloco"
    (keydown)="keyDown($event)"
    (openedChange)="$event ? search?.focus() : searchControl.reset('')"
    #select
>
    <ng-content select="label" ngProjectAs="label"></ng-content>
    <mat-select-trigger *ngrxLet="selectedCountry$ as selectedCountry">
        <dtm-ui-country-flag-display [country]="selectedCountry?.alpha3Code"></dtm-ui-country-flag-display>
        <span class="country-name">{{ selectedCountry?.displayName }}</span>
    </mat-select-trigger>
    <dtm-ui-input-field class="search">
        <input
            #search
            matInput
            [formControl]="searchControl"
            [placeholder]="'dtmUi.countrySelect.search' | transloco"
            (keydown.space)="$event.stopPropagation()"
            (keydown.enter)="setControlValueFromSearch()"
    /></dtm-ui-input-field>
    <p class="empty-list" *ngIf="!listOfCountriesDisplay.length">{{ "dtmUi.countrySelect.emptyListInfo" | transloco }}</p>
    <dtm-ui-select-option
        [value]="country.alpha3Code"
        *ngFor="let country of listOfCountriesDisplay; trackBy: countryListItemTrack"
        isCustomContent
    >
        <dtm-ui-country-display [country]="country.alpha3Code"></dtm-ui-country-display>
    </dtm-ui-select-option>
    <ng-content select=".field-hint" ngProjectAs=".field-hint"></ng-content>
    <ng-content select=".field-error" ngProjectAs=".field-error"></ng-content>
</dtm-ui-select-field>
